import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import Right from '../right/Right';
import CatMenuDesktop from './CatMenuDesktop';
import { fetchInitialData2 } from "../../fetchData";
import '../ColoringPage.css';
import * as action from '../Actions';
import Service from '../../service/Service';
import withLocation from "../../../withLocation";
const service = new Service();

class NoResult extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let categoryList = [];
        let filterSubCategory = [];
        let filterMainCategory = [];
        let categoryListAlphabeticaly = [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData --- ", serverSideData);
        if (serverSideData) {
            
            if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1 && serverSideData['data1']['result'] && serverSideData['data1']['result'][0]) {
                categoryList = serverSideData['data1']['result'][0];
            }

            if (serverSideData['data2'] && serverSideData['data2']['msg'] == 1) {
                categoryListAlphabeticaly = serverSideData['data2']['result'];
            }
        }
        // console.log("landingCat",landingCat);


        this.state = {
            page: "ColouringPageLanding",
            metaTitle:[],
            metaDescription: [],
            initialData: initialData,
            categoryList: categoryList,
            filterMainCategory:filterMainCategory,
            filterSubCategory:filterSubCategory,
            mainCategoryCont: 1,
            categoryListAlphabeticaly:categoryListAlphabeticaly
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var cUrl = reqUrl;
        let obj1 = {
            url: global.api_url + "colouringpages/getallmaincategory",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 100
            })
        };

        let obj2 = {
            url: global.api_url + "colouringpages/getallmaincategorynsubcatcount",
            body: JSON.stringify({
                "pageno": 1,
                "pagesize": 10
            })
        };
        // return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));

        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    render() {
        return (
            <main className="main-container colouring-page">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <CatMenuDesktop eleRef={this} mainCategoryCont={this.state.mainCategoryCont} />
                <div className="colouringpage-content left">
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/coloring-pages-printables/")} className="R11_9e">Coloring Pages & Printables</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>No Result Found</span>
                        </div>
                        <h1 className="B24_00 left" id="skipToH1" tabIndex={0}>Colouring Page</h1>

                        <div className="right filter" onClick={() => action.openCatgFilter(this)}>
                            <span data-icon-font="K" className="icon M16_42 Dev_Fltr_icn"></span>
                            <span className="M16_42 Dev_Fltr_btn">Filter</span>
                        </div>
                        <input type="hidden" id="pgNo" value="" />
                    </div>
                    <div className="sub-container left">
                        <div className="data-container left">
                            <div className="no-results-cnt">
                                <div className="no-result-icon">
                                    <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/No-Results-Found-Icons.png'} />
                                </div>
                                <div className="B26_42 noresult-txt">No Results Found</div>
                                <div className="R18_75 noresult-subtext"><span>We couldn't find any search results.</span><span className="give-it-another-go"> Give it another go.</span></div>
                                <div className="searchagain-btn"><a href={service.getRedirectUrl("/coloring-pages-printables/")} className="M18_ff">SEARCH AGAIN</a></div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-overlay sub-category-overlay">
                <div className="filter-popup filter_popups">
                    <div className="filter_by">
                        <span className="M18_42">Filter By</span>
                        <span className="right icon" data-icon-font="C" onClick={() => action.closeFilter()}></span>
                    </div>
                    <div className="catg_filter">
                        <ul className="left">
                            <li className="category_list">
                                <ul className="left categorieslist">
                                    {this.state.filterMainCategory && this.state.filterMainCategory.length > 0 && this.state.filterMainCategory.map((list, index) =>
                                        <li  key={index} className={(this.state.filterCategoryId == list.subcategoryId) ? "gender active" : "gender"} onClick={() => action.LoadSubOfSubcategorylist(list.subcategoryId,list.subcategoryName)}>
                                            <span className="catname R14_42">{list.subcategoryName}</span>
                                            <div className="subcatCount">1 Selected</div>
                                        </li>
                                    )}
                                </ul>
                            </li> 
                            <li className="subcategory_list">
                                <div className="filter_search left">
                                    <span className="icon searchflticon" data-icon-font="'" onClick={() => action.SearchCategorydata(this)} ></span>
                                    <input className="R14_42" type="text" id="sabcat_search" placeholder="Search"  onChange={event => action.updateSearchInput(event,this)} />
                                </div>
                                <ul className="subgender subcategorieslist active">
                                {this.state.filterSubCategory && this.state.filterSubCategory.length > 0 && this.state.filterSubCategory.map((subCat, index) =>
                                    <li key={index} onClick={() => action.gotoDetailsPage(service.replaceSymbols(this.props.location.pathname.split("?")[0].split('/')[2]),service.replaceSymbols(subCat.categoryName), service.replaceSymbols(subCat.subcategoryName),subCat.subcategoryId)}> 
                                        <input className="check left" type="checkbox" ></input>
                                        <span className="subcatname R14_42">{subCat.subcategoryName}</span>
                                    </li>
                                 )}    
                                </ul>
                            </li>
                        </ul>
                    </div>
                   
                </div>
            </div>
            <div className="category-filter-overlay">
                <div className="catg-filter">
                    <div className="catgFilter-top">
                        <div className="serach-field left">
                            <span data-icon-font="'" onClick={() => action.SearchCategorydata(this)}></span>
                            <input type="text" placeholder="Search Category" id="categoryFilterText" onChange={event => action.updateSearchInput(event,this)} />
                        </div>
                        <div className="left alphabets-strip">
                        <span className="alpha">#</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('A') ? 'alpha' :  'active-alpha'}>A</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('B') ? 'alpha' :  'active-alpha'}>B</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('C') ? 'alpha' :  'active-alpha'}>C</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('D') ? 'alpha' :  'active-alpha'}>D</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('E') ? 'alpha' :  'active-alpha'}>E</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('F') ? 'alpha' :  'active-alpha'}>F</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('G') ? 'alpha' :  'active-alpha'}>G</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('H') ? 'alpha' :  'active-alpha'}>H</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('I') ? 'alpha' :  'active-alpha'}>I</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('J') ? 'alpha' :  'active-alpha'}>J</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('K') ? 'alpha' :  'active-alpha'}>K</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('L') ? 'alpha' :  'active-alpha'}>L</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('M') ? 'alpha' :  'active-alpha'}>M</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('N') ? 'alpha' :  'active-alpha'}>N</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('O') ? 'alpha' :  'active-alpha'}>O</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('P') ? 'alpha' :  'active-alpha'}>P</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('Q') ? 'alpha' :  'active-alpha'}>Q</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('R') ? 'alpha' :  'active-alpha'}>R</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('S') ? 'alpha' :  'active-alpha'}>S</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('T') ? 'alpha' :  'active-alpha'}>T</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('U') ? 'alpha' :  'active-alpha'}>U</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('V') ? 'alpha' :  'active-alpha'}>V</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('W') ? 'alpha' :  'active-alpha'}>W</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('X') ? 'alpha' :  'active-alpha'}>X</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('Y') ? 'alpha' :  'active-alpha'}>Y</span>
                            <span className={Object.keys(this.state.categoryListAlphabeticaly).includes('Z') ? 'alpha' :  'active-alpha'}>Z</span>
                        </div>
                        <div data-icon-font="C" className="close-ic right" onClick={() => action.closeCatgFilter()}></div>
                    </div>
                    <div className="catg-list-cnt">
                        <div className="catg-list">
                            <ul className="list-colm col1">

                                {this.state.categoryListAlphabeticaly && Object.keys(this.state.categoryListAlphabeticaly).map(key => (
                                    <div>
                                    <li key={`cat_${key}`}>{key}</li>
                                    {this.state.categoryListAlphabeticaly[key].map((subcat, i) => {     
                                       return (<li key={`cat_${i}`}>
                                        <label  onClick={() => action.LoadSubcategorylist(subcat.categoryId,subcat.categoryName,this)}>
                                            <input type="checkbox" ></input>
                                            <span className="catg-name R14_61">{subcat.categoryName} </span>
                                            <span>({subcat.subcategoryCount})</span>
                                        </label>
                                    </li>) 
                                    })}
                                    </div>
                                    

                                ))}
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </div>
                </div>
            </main >
        )
    }
}

export default withLocation(NoResult);
